<p-sidebar 
  [(visible)]="visible" 
  position="right" 
  [baseZIndex]="10000"
  (onHide)="onSidebarHide()"
  styleClass="enquiry-sidebar"
>

  <!-- Header -->
  <div class="sidebar-header">
    <div class="title">
      <i class="pi pi-envelope"></i>
      <h3>Contact Us</h3>
    </div>
    <p>We’ll get back to you shortly</p>
  </div>

  <!-- Form -->
  <form [formGroup]="form" (ngSubmit)="submit()" class="form">

    <!-- Name -->
    <div class="field">
      <input pInputText type="text" placeholder="Full Name" formControlName="name" />
      <small *ngIf="form.get('name')?.invalid && form.get('name')?.touched">Name is required</small>
    </div>

    <!-- Organization -->
    <div class="field">
      <input pInputText type="text" placeholder="Organization Name" formControlName="organization" />
      <small *ngIf="form.get('organization')?.invalid && form.get('organization')?.touched">Organization is required</small>
    </div>

    <!-- Plan Dropdown -->
    <div class="field">
      <p-dropdown 
        [options]="planOptions" 
        placeholder="Select Plan"
        formControlName="plan">
      </p-dropdown>
      <small *ngIf="form.get('plan')?.invalid && form.get('plan')?.touched">Please select a plan</small>
    </div>

    <!-- Phone -->
    <div class="field">
      <input pInputText type="text" placeholder="Phone Number" formControlName="phone" />
      <small *ngIf="form.get('phone')?.invalid && form.get('phone')?.touched">Enter valid phone</small>
    </div>

    <!-- Email -->
    <div class="field">
      <input pInputText type="email" placeholder="Email Address" formControlName="email" />
      <small *ngIf="form.get('email')?.invalid && form.get('email')?.touched">Enter valid email</small>
    </div>

    <!-- Query -->
    <div class="field">
      <textarea pInputTextarea rows="4" placeholder="Your Query" formControlName="query"></textarea>
      <small *ngIf="form.get('query')?.invalid && form.get('query')?.touched">Query is required</small>
    </div>

    <!-- Submit -->
    <button 
      pButton 
      type="submit" 
      label="Submit" 
      class="submit-btn"
    ></button>

  </form>

</p-sidebar>

<!-- Floating Enquiry Tab -->
<div class="enquiry-tab" *ngIf="!visible" (click)="openSidebar()">
  <i class="pi pi-envelope"></i>
  <span>Contact Us</span>
</div>